<template>
  <v-text-field
    :color="'primary'"
    v-model="localvalue"
    class="pa-0"
    single-line
    hide-details
    outlined
    background-color="white"
    :label="placeholder"
    :maxlength="length"
    :type="password ? 'password' : 'text'"
    readonly
  >
    >
    <template v-slot:prepend class="out-margin">
      <v-btn
        large
        @click="operation(localvalue, 'subtract')"
        :disabled="localvalue == '00:30' || auxValue == 0"
        :style="
          $vuetify.breakpoint.xs
            ? '8.5vh'
            : $vuetify.breakpoint.md
            ? 'height: 5vh'
            : 'height: 7.5vh'
        "
        color="primary"
      >
        <v-icon v-text="'mdi-minus'" />
      </v-btn>
    </template>
    <template v-slot:append-outer>
      <v-btn
        large
        @click="operation(localvalue, 'add')"
        :disabled="localvalue == '08:00' || auxValue == 2"
        color="primary"
        :style="
          $vuetify.breakpoint.xs
            ? '8.5vh'
            : $vuetify.breakpoint.md
            ? 'height: 5vh'
            : 'height: 7.5vh'
        "
      >
        <v-icon v-text="'mdi-plus'" />
      </v-btn>
    </template>
  </v-text-field>
</template>
<script>
import { time } from "@/utils";

const props = {
  value: {
    default: "00:00",
    type: String,
  },
  placeholder: {
    default: "Ingrese el campo",
    type: String,
  },
  length: {
    default: undefined,
    type: Number,
  },
  max16: {
    default: false,
    type: Boolean,
  },
  password: {
    default: false,
    type: Boolean,
  },
  min8: {
    default: false,
    type: Boolean,
  },
  alfaNumeric: {
    default: false,
    type: Boolean,
  },
  number: {
    default: false,
    type: Boolean,
  },
  formReserv: undefined,
};

export default {
  data() {
    return {
      localvalue: this.value,
      rank: ["1 - 4", "5 - 10", "11 - 20"],
      auxValue: this.value,
    };
  },
  props: props,
  mounted() {
    this.number ? (this.localvalue = "1 - 4") : (this.localvalue = "00:30");
    this.number ? (this.auxValue = 0) : (this.auxValue = "00:30");
  },
  methods: {
    operation(hour, type) {
      this.auxValue = this.number
        ? type == "add"
          ? this.auxValue + 1
          : this.auxValue - 1
        : time.hourAdd(hour, type);
      this.localvalue = this.number ? this.rank[this.auxValue] : this.auxValue;
      this.$emit("click", this.localvalue, this.formReserv, this.number);
    },
  },
};
</script>
<style scoped>
v-btn {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
</style>
